import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import useBreakpoint from '@/hooks/use-break-point';
import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import showReleaseToast from '@/utils/helpers/show-release-toast';

const useDeleteReleaseNote = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const isMobile = useBreakpoint('mobile');

  return useMutation({
    mutationFn: async (id: string | number) => {
      const { data } = await axiosInstance.delete(API_ROUTES.releaseNote(id));

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['release-note-lists'] });

      showReleaseToast({
        variant: 'success',
        title: t('release_note.delete.title'),
        description: t('release_note.delete.description'),
        isMobile,
      });
    },
    onError: () => {
      showReleaseToast({
        variant: 'error',
        title: t('errors.general'),
        description: t('errors.delete_release_note.api'),
        isMobile,
      });
    },
  });
};

export default useDeleteReleaseNote;
